<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tnU3cX/tc-custom/9781504059985.jpg?1700849918812" alt="This image is the cover for the book Drown All the Dogs, The Neil Hockaday Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Drown All the Dogs, The Neil Hockaday Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An NYPD detective travels to Ireland to investigate his own family’s past in this “smart, textured, immensely readable” mystery</b><b> (<i>The Washington Post Book World</i>).</b><br/>  <br/> Neil Hockaday’s father died in World War II before his son could ever know him, and now the police detective is visiting Ireland to meet his last living relative and try to fill in the blanks of his family history. But while he’s on vacation, death isn’t taking a holiday. The apparent suicides of a retired priest and two cops—and an Irish woman’s death in a bombing—combine to keep Hock busy on both sides of the Atlantic in this rich, riveting police procedural, filled with “lively and literate” dialogue, from an Edgar Award–winning author (<i>The New York Times Book Review</i>).<br/>  <br/> “Unusual and engrossing.” —<i>Los Angeles Times Book Review</i><br/>  <br/> “Dense and vibrant . . . as charming as an Irish brogue.” —<i>Publishers Weekly</i><br/>  <br/> “One of the most lively and memorable novels to come out this year.” —<i>Richmond Times-Dispatch</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Adcock
      </h2>
      
      <p class="authorDescription body article">Thomas Adcock (b. 1947) is an Edgar Award&ndash;winning novelist and journalist from Detroit. Since 1985, Adcock has written over a dozen short stories and anthologies, in addition to his popular crime thrillers starring New York&ndash;based detective Neil Hockaday.&#160; Adcock was involved in PEN International, The Mystery Writers of America, and cofounded the North American chapter of the International Association of Crime Writers. He currently resides in New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e6a7e80